import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { localStorage } from '@/utils/storage';

export function useCollectClickId() {
  const [params] = useSearchParams();

  useEffect(() => {
    const fbclid = params.get('fbclid');
    const ttclid = params.get('ttclid');

    if (fbclid) {
      localStorage.save('fbclid', fbclid);
    }

    if (ttclid) {
      localStorage.save('ttclid', ttclid);
    }
  }, [params]);
}

export default useCollectClickId;
